<template>
    <v-dialog v-model="dialog" scrollable max-width="600px" hide-overlay>
        <template v-slot:activator="{ on }">
            <v-btn color="secondary" class="mx-2" small icon v-on="on">
                <v-tooltip bottom color="primary">
                    <template v-slot:activator="{ on }">
                        <v-icon small v-on="on">mdi-pencil</v-icon>
                    </template>
                    <span>edit insight</span>
                </v-tooltip>
            </v-btn>
        </template>
        <v-card v-if="!loading">
            <v-card-title class="subtitle-2 pt-6 text-pre-wrap">
                New params for insight № <span class="secondary--text">{{ insight.id }}</span>
            </v-card-title>
            <v-divider></v-divider>
            <v-card-text class="black--text">
                <v-container grid-list-md>
                    <v-form v-model="valid" ref="form" validation>
                        <v-row>
                            <!--segment-->
                            <v-col cols="12" sm="6" md="6">
                                <v-text-field dense color="secondary" label="segment" v-model="segment" name="segment"
                                    type="text" readonly>
                                </v-text-field>
                            </v-col>
                            <v-col cols="12" md="4" sm="6">
                                <v-text-field dense 
                                    color="secondary" label="weight" 
                                    v-model.number="weight"
                                    name="weight" 
                                    type="text" 
                                    :rules="[rules.number]"
                                    @change="onceMore()">
                                </v-text-field>
                            </v-col>
                            <!--text-->
                            <v-col cols="12" sm="12" md="12">
                                <v-textarea dense counter rows="2" outlined auto-grow v-model="text" 
                                    color="secondary" label="text" 
                                    @change="onceMore()" :rules="[rules.required]">
                                </v-textarea>
                            </v-col>
                        </v-row>
                    </v-form>
                </v-container>
                <v-row justify="center" class="error--text">{{ error }}</v-row>
                <v-row justify="center" class="text-pre-wrap subtitle-2">
                    {{ message }}
                </v-row>
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="secondary" text class="text-capitalize" :disabled="!valid || Boolean(error)"
                    @click="editInsight">Save
                </v-btn>

                <v-btn color="secondary" text class="text-capitalize" @click="closeDialog">
                    Close
                </v-btn>

            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>

export default {
    name: 'EditInsight',
    props: ['insight'],
    data() {
        return {
            dialog: false,
            valid: false,
            error: '',
            message: '',
            rules: {
                required: v => !!v || 'this field is required',
                number: v => /^[+]?[0-9]/.test(v) || 'it\'s expected number',
            },
            //props
            text: this.insight.text,
            segment: this.insight.segment?.name,
            weight: this.insight.weight,
        }
    },
    computed: {
        loading() {
            return this.$store.getters.loading
        },
        locale() {
            return this.$store.getters.locale;
        },
    },
    methods: {
        onceMore() {
            this.error = ''
            this.message = '';
        },
        async editInsight() {

            if (this.$refs.form.validate()) {

                const insight = {
                    id: this.insight.id,
                    text: this.text.trim(),
                    weight: this.weight, 
                }
                /*console.log(insight);*/
                try {
                    //edit insight
                    await this.$store.dispatch('editInsight', insight)
                    this.closeDialog()
                }
                catch (error) {
                    this.error = `${error.message}`;
                    this.message = '';
                    this.$store.dispatch('setError', error.message)//throw error
                }
            }
        },
        closeDialog() {
            //reset
            this.dialog = false;
            this.error = '';
            this.message = '';
            this.text = this.insight.text;
            this.segment = this.insight.segment?.name;
            this.weight = this.insight.weight;
        }
    },
}
</script>